import { CustomEntityService } from './../apiclient/api/customEntity.service';
import { CustomEntityFull } from './../apiclient/model/customEntityFull'; //Esther F006-EV03
import { CustomEntityType } from './../apiclient/model/customEntityType';
import { EditableCustomForm } from './../apiclient/model/editableCustomForm';
import { FramelinksService } from './../apiclient/api/framelinks.service';
import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { Injectable } from '@angular/core';
import { UserService, CompanyService, SystemService, CustomformsService, Field } from '../apiclient';
import { Observable, Subscriber } from 'rxjs';
import * as moment from 'moment';
import { TitleComponent } from 'ng2-smart-table/lib/components/thead/cells/title/title.component';

/**
 * Servicio que aglutina los métodos de acceso a la información vinculada a la sesión del usuario
 */
@Injectable({
  providedIn: 'root',
})
export class UserSessionService {





  public userRole: String;
  public user: any;
  private sessionObserbable: Observable<any>;
  private sessionSubscriber: Subscriber<any>;
  private cachedCompaniesList: [any];
  private cachedFieldList: Field[];
  private cachedUsersList: [any];
  private cachedEntitiesList : any;
  private cachedFramelinksList: {};
  private cachedListaCuadernos: {};
  private cachedRegionsList: string[];
  private cachedCustomForms: EditableCustomForm[];
  private cachedCustomFullEntities: CustomEntityFull[];
  private cachedCustomFullEntityTypes: CustomEntityType[]; //Esther F006-EV03
  sessionObserver: Subscriber<any>;
  listSessionObserver: Array<Subscriber<any>> = Array();
  listCustomEntitiesObserver: Array<Subscriber<any>> = Array();
  listCustomEntityTypesObserver: Array<Subscriber<any>> = Array(); //Esther F006-EV03
  accessToken: string;
  isAuthenticated: boolean;
  private entitiesCompany: any;
  public legacyEntities = [];

  constructor(private authService: NbAuthService,
    private apiUserService: UserService,
    private companyService: CompanyService,
    private framelinksService: FramelinksService,    private customformsService: CustomformsService,
    private customEntitesService: CustomEntityService,
    private systemService: SystemService) {


    this.authService.onAuthenticationChange().subscribe((authenticated) => {
      if(!authenticated){
        console.log("Ya no está utenticado")
        this.accessToken = null;
      }

    })

    this.authService.onTokenChange().subscribe((token: NbAuthJWTToken) => {

      console.log("Token Change");

      if(token != null && token.toString() != '' && token.isValid()){
      console.log(token.toString());
      this.accessToken = "Bearer "+token.toString();

      apiUserService.user("Bearer "+token.toString()).subscribe(usuario => {

        this.user = usuario;
        console.log(this.user);
        //this.sessionObserver.next(this.user);
        console.log("Ya tenemos usuario en sesion "+ this.accessToken);
        this.isAuthenticated = true;

        this.triggerSessionCreated();

      });
    }else{
      this.closeSession();
    }

  });

  }

  private triggerSessionCreated() {
    this.listSessionObserver.forEach((subscriber) => {
      subscriber.next(this.user);

    });
  }

  /**
   * Evento que se dispara al crear la sesión
   * @returns
   */
  onSessionCreated() {
    if (this.isAuthenticated){
      return new Observable((observer) => {
        observer.next(this.user);

      });
    }else{
      this.sessionObserbable = new Observable<any>((observer) => {
        this.listSessionObserver.push(observer);
      });
      return this.sessionObserbable;
    }

  }

  /**
   * Fuerza el refresco de la lista de compañías
   */
  refreshCompanyCache():void{
    this.cachedCompaniesList = null;
    this.getCompanies();
  }

  /**
   * Obtiene el listado de compañías
   * @returns
   */
  getCompanies(): Observable<any>{
    return new Observable((observer) => {
      if(this.cachedCompaniesList != null){
        observer.next(this.cachedCompaniesList);
      }else{
        this.companyService.companies(this.accessToken).subscribe((companies) => {
          this.cachedCompaniesList = companies as [any];
          observer.next(this.cachedCompaniesList);
        })
      }
    })
  }


  /**
   * Obtiene el listado cacheado de Parcelas
   * @returns
   */
  getCachedFieldList(): Observable<any>{
    return new Observable((observer) => {
      this.getCachedEntitiesList().subscribe((entities) => {
        observer.next(entities.fieldlist);
      });
  });
  }
  /**
   * Obtiene el listado cacheado de parcelas en modo asíncrono
   * @returns
   */
  async getPromiseFieldList(){
    return new Promise(resolve => {
      this.getCachedFieldList().subscribe((v)=> {
        resolve(v)
      })
    })
  }

  /**
   * Obtiene el listado cacheado de regiones
   * @returns
   */
  getCachedRegionsList(): Observable<any>{
    return new Observable((observer) => {
      if (this.cachedRegionsList != null){
        observer.next(this.cachedRegionsList)
      }else{
        this.getCachedFieldList().subscribe((parcelas) => {
          observer.next(this.cachedRegionsList)
        });
      }
    })
  }

  /**
   * Elimina la lista cacheada de parcelas
   */
removeCachedFieldList(): void{
  console.log("Borramos la cache de fields")
  this.cachedFieldList = null;
  console.log(this.cachedFieldList)
}

/**
 * Elimina al lista cacheada de entidades
 */
  removeCachedEntitiesList(): void {
    this.cachedEntitiesList = null;
  }

  removeCachedListaCuadernos(): void {
    this.cachedListaCuadernos = null;
  }

  getCachedListaCuadernos(): Observable<any>{
    return new Observable((observer) => {
      if ( this.cachedListaCuadernos != null){
        observer.next(this.cachedListaCuadernos)
      }else{


        this.systemService.listaCuadernos(this.accessToken).subscribe((lista) => {
          this.cachedListaCuadernos = lista;
          observer.next(this.cachedListaCuadernos);
        });
      }
    })
  }
  /**
   * Obtiene la lista cacheada de Plagas
   * @returns
   */
  getCachedDiseaseList(): Observable<any>{
    return new Observable((observer) => {
        this.getCachedEntitiesList().subscribe((entities) => {
          observer.next(entities.diseaselist);
        });
    });
  }

  /**
   * Obtiene la lista cacheada de Mantenimientos
   * @returns
   */
  getCachedMaintenanceList(): Observable<any> {
    return new Observable((observer) => {
      this.getCachedEntitiesList().subscribe((entities) => {
        observer.next(entities.maintenancelist);
      });
  });
  }

  /**
   * Obtiene la lista cacheada de Productos
   * @returns
   */
  getCachedProductList(): Observable<any> {
    return new Observable((observer) => {
      this.getCachedEntitiesList().subscribe((entities) => {
        observer.next(entities.productlist);
      });
  });
  }

  /**
   * Obtiene la lista  cacheada de maquinaria
   * @returns
   */
  getCachedMachineryList(): Observable<any> {
    return new Observable((observer) => {
      this.getCachedEntitiesList().subscribe((entities) => {
        observer.next(entities.machinerylist);
      });
  });
  }



  /**
   * Obtiene la lista cacheada de tipos de Muestreo
   * @returns
   */
  getCachedSamplingList(): Observable<any>  {
    return new Observable((observer) => {
      this.getCachedEntitiesList().subscribe((entities) => {
        observer.next(entities.customforms.filter( cf => cf.module_name == 'sampling'));
      });
  });
  }

  /**
   * Obtiene la lista cacheada de entidades personalizadas
   * @returns
   */
  getCachedCustomEntitiesFullList(companyid): Observable<any>{
    if(companyid!= undefined){
      this.cachedCustomFullEntities = null;
      this.entitiesCompany = companyid;

    }
    return new Observable( (observer) => {

      this.listCustomEntitiesObserver.push(observer)
      this.triggerCustomEntitiesChange(observer);
    })
  }




  /** Esther F006-EV03
   * Obtiene la lista cacheada de entidades personalizadas
   * @returns
   */
   getCachedCustomEntityTypesFullList(): Observable<any>{
    return new Observable( (observer) => {

      this.listCustomEntityTypesObserver.push(observer)
      this.triggerCustomEntityTypesChange(observer);
    })
  }

  /**
   * Obtiene una entidad personalizada cacheada
   * @param entityid Id de entidad
   * @returns
   */
  async getCachedEntity(entityid){
    return this.cachedCustomFullEntities.filter(entity => entity.id == entityid)[0];
  }

  /**
   * Fuerza el refresco de las entidades personalizadas cacheadas
   */
  invalidateCachedCustomEntities(){
    this.cachedCustomFullEntities = null;
    this.listCustomEntitiesObserver.forEach(observer => {
      this.triggerCustomEntitiesChange(observer);
    })
  }

  /** Esther F006 EV03
   * Fuerza el refresco de las entidades personalizadas cacheadas
   */
   invalidateCachedCustomEntityTypes(){
    this.cachedCustomFullEntityTypes = null;
    this.listCustomEntityTypesObserver.forEach(observer => {
      this.triggerCustomEntityTypesChange(observer);
    })
  }

  /**
   * @ignore
   * @param observer
   */
  private async triggerCustomEntitiesChange(observer: Subscriber<any>) {
    if (this.cachedCustomFullEntities != null) {
      observer.next(this.cachedCustomFullEntities);
    } else if(this.entitiesCompany == undefined || this.entitiesCompany == -1){
      this.customEntitesService.customEntitieslist(this.accessToken,null,true).subscribe((customEntities) => {

        this.cachedCustomFullEntities = customEntities;
        if(null == this.cachedEntitiesList) this.cachedEntitiesList = {};
        try{
             this.consolidateDefaultEntities();
        }catch(e){
            console.log(e)
        }
        observer.next(this.cachedCustomFullEntities);
      });

    } else{

      this.customEntitesService.customEntitiesByCompany(this.entitiesCompany,this.accessToken,true).subscribe((customEntities) => {
        this.cachedCustomFullEntities = customEntities;
        observer.next(this.cachedCustomFullEntities);
      });
    }
  }

/**
 * Sustituir link de cada hijo del menú entidades
 */
public consolidateDefaultEntities(){

  this.legacyEntities = [];
  //PARCELAS
  var customEntitiesTipo = this.cachedCustomFullEntities.filter(c => c.type == 1);
  var IdMasAntiguo = 0;
  var NombreMasAntiguo = "";
  for (let i = 0; i < customEntitiesTipo.length; i++){
    if (IdMasAntiguo == 0){
      IdMasAntiguo = customEntitiesTipo[i].id;
      NombreMasAntiguo = customEntitiesTipo[i].name;
    } else if (IdMasAntiguo > customEntitiesTipo[i].id){
      IdMasAntiguo = customEntitiesTipo[i].id
      NombreMasAntiguo = customEntitiesTipo[i].name;
    }
  }

  if (IdMasAntiguo != 0 && !this.legacyEntities.find(e => e.id === NombreMasAntiguo)){
    this.legacyEntities.push({"id": NombreMasAntiguo, "value":IdMasAntiguo,"tipo":1});
    this.cachedEntitiesList.fieldlist = this.cachedCustomFullEntities.find(e => e.id === IdMasAntiguo).elements.filter((elemento) => {
      return elemento.archivedAt === null && elemento.disabledAt === null;
    });
  }

  //PRODUCTOS
  customEntitiesTipo = this.cachedCustomFullEntities.filter(c => c.type == 2);
  IdMasAntiguo = 0;
  NombreMasAntiguo = "";
  for (let i = 0; i < customEntitiesTipo.length; i++){
    if (IdMasAntiguo == 0){
      IdMasAntiguo = customEntitiesTipo[i].id;
      NombreMasAntiguo = customEntitiesTipo[i].name;
    } else if (IdMasAntiguo > customEntitiesTipo[i].id){
      IdMasAntiguo = customEntitiesTipo[i].id
      NombreMasAntiguo = customEntitiesTipo[i].name;
    }
  }
  if (IdMasAntiguo != 0 && !this.legacyEntities.find(e => e.id === NombreMasAntiguo)){
    this.legacyEntities.push({"id": NombreMasAntiguo, "value":IdMasAntiguo,"tipo":2})
  }
  //MAQUINARIAS
  customEntitiesTipo = this.cachedCustomFullEntities.filter(c => c.type == 3);
  IdMasAntiguo = 0;
  NombreMasAntiguo = "";
  for (let i = 0; i < customEntitiesTipo.length; i++){
    if (IdMasAntiguo == 0){
      IdMasAntiguo = customEntitiesTipo[i].id;
      NombreMasAntiguo = customEntitiesTipo[i].name;
    } else if (IdMasAntiguo > customEntitiesTipo[i].id){
      IdMasAntiguo = customEntitiesTipo[i].id
      NombreMasAntiguo = customEntitiesTipo[i].name;
    }
  }
  if (IdMasAntiguo != 0 && !this.legacyEntities.find(e => e.id === NombreMasAntiguo)){
    this.legacyEntities.push({"id": NombreMasAntiguo, "value":IdMasAntiguo,"tipo":3})
  }
  //PLAGAS
  customEntitiesTipo = this.cachedCustomFullEntities.filter(c => c.type == 4);
  IdMasAntiguo = 0;
  NombreMasAntiguo = "";
  for (let i = 0; i < customEntitiesTipo.length; i++){
    if (IdMasAntiguo == 0){
      IdMasAntiguo = customEntitiesTipo[i].id;
      NombreMasAntiguo = customEntitiesTipo[i].name;
    } else if (IdMasAntiguo > customEntitiesTipo[i].id){
      IdMasAntiguo = customEntitiesTipo[i].id
      NombreMasAntiguo = customEntitiesTipo[i].name;
    }
  }
  if (IdMasAntiguo != 0 && !this.legacyEntities.find(e => e.id === NombreMasAntiguo)){
    this.legacyEntities.push({"id": NombreMasAntiguo, "value":IdMasAntiguo,"tipo":4})
    this.cachedEntitiesList.diseaselist = this.cachedCustomFullEntities.find(e => e.id === IdMasAntiguo).elements.filter((elemento) => {
      return elemento.archivedAt === null && elemento.disabledAt === null;
    }).map(({id, name}) => ({id, name}));
  }
  //MANTENIMIENTOS
  customEntitiesTipo = this.cachedCustomFullEntities.filter(c => c.type == 5);
  IdMasAntiguo = 0;
  NombreMasAntiguo = "";
  for (let i = 0; i < customEntitiesTipo.length; i++){
    if (IdMasAntiguo == 0){
      IdMasAntiguo = customEntitiesTipo[i].id;
      NombreMasAntiguo = customEntitiesTipo[i].name;
    } else if (IdMasAntiguo > customEntitiesTipo[i].id){
      IdMasAntiguo = customEntitiesTipo[i].id
      NombreMasAntiguo = customEntitiesTipo[i].name;
    }
  }
  if (IdMasAntiguo != 0 && !this.legacyEntities.find(e => e.id === NombreMasAntiguo)){
    this.legacyEntities.push({"id": NombreMasAntiguo, "value":IdMasAntiguo,"tipo":5})
    this.cachedEntitiesList.maintenancelist = this.cachedCustomFullEntities.find(e => e.id === IdMasAntiguo).elements.filter((elemento) => {
      return elemento.archivedAt === null && elemento.disabledAt === null;
    }).map(({id, name}) => ({id, name}));
  }
  }

  /** Esther F006-EV03
   * @ignore
   * @param observer
   */
   private async triggerCustomEntityTypesChange(observer: Subscriber<any>) {
    if (this.cachedCustomFullEntityTypes != null) {
      observer.next(this.cachedCustomFullEntityTypes);
    } else {
      this.customEntitesService.customEntityTypeslist(this.accessToken).subscribe((customEntityTypes) => {

        this.cachedCustomFullEntityTypes = customEntityTypes;
        observer.next(this.cachedCustomFullEntityTypes);
      });
    }
  }

  /**
   * Devuelve la lista cacheada de tipos de Cauderno de campo
   * @returns
   */
  getCachedNotebookList(): Observable<any>  {
    return new Observable((observer) => {
      this.getCachedEntitiesList().subscribe((entities) => {
          observer.next(entities.customforms.filter( cf => cf.module_name == 'fieldnotebook'));

      });
  });
  }

  /**
   * Devuelve la lista cacheada de usuarios
   * @returns
   */
  getCachedUsersList(): Observable<any>{
    return new Observable((observer) => {
       if(this.cachedUsersList != null){
         observer.next(this.cachedUsersList)
       }else{
         this.apiUserService.usersfromowncompany(this.accessToken).subscribe((users) => {
           this.cachedUsersList = users as [any];
           observer.next(this.cachedUsersList)
         })
       }

    });
  }

  /**
   * @ignore
   * @returns
   */
  getCachedEntitiesList(): Observable<any>{
    return new Observable((observer) => {
      if ( this.cachedEntitiesList != null && this.cachedEntitiesList.customforms != undefined){
        observer.next(this.cachedEntitiesList)
      }else{


        this.systemService.syncsystem(moment('1990-01-01T00:00:00.000+00:00').toDate(),this.accessToken).subscribe((entities) => {
          this.cachedEntitiesList = Object.assign(entities,this.cachedEntitiesList);
          if(this.cachedEntitiesList.customforms == undefined){
            this.cachedEntitiesList.customforms = [];
          }
          observer.next(this.cachedEntitiesList);
        });
      }
    })
  }

  /**
   * @ignore
   * @param framelinks
   * @returns
   */
  generateAndOrganize(framelinks: [any]): any{
    let cardlinks = {'Mapas':{'nocategory':[]},'Clima':{'nocategory':[]},'Informes':{'nocategory':[]},'Menú':{'nocategory':[]}}


    framelinks.forEach((cardlink)=> {
      try{
      if(cardlink.subcategory != null){
          if(typeof cardlinks[cardlink.category][cardlink.subcategory] == 'undefined'){

            //no existe
            cardlinks[cardlink.category][cardlink.subcategory] = [];
          }

          cardlinks[cardlink.category][cardlink.subcategory].push(cardlink);
      }else{
        cardlinks[cardlink.category]['nocategory'].push(cardlink);
      }
    }catch(error){
      console.log("Error al generar cardlink");
    }
    })

    return cardlinks;
  }

  /**
   * Devuelve la lista cacheada de Framelinks
   * @returns
   */
  getFramelinks(): Observable<any>{
    return new Observable((observer) => {
      if(this.cachedFramelinksList != null){
        observer.next(this.cachedFramelinksList);
      }else{
        this.framelinksService.framelinksfromowncompany(this.accessToken).subscribe((framelinks) => {
          this.cachedFramelinksList = this.generateAndOrganize(framelinks as [any]);
          observer.next(this.cachedFramelinksList);
        });
      }
    })
  }

  /**
   * Devuelve un custom form
   * @param idform Identificador del customform
   * @returns
   */
  getCustomForm( idform): Observable<any>{
    return new Observable((observer) => {
      this.getCustomForms().subscribe( (customForms) => {
        console.log(customForms)
        let customForm = customForms.find( e => e.id === idform);
        observer.next(customForm);
      })
    })
  }

  /**
   * Devuelve la lista cacheada de Custom Forms
   * @returns
   */
  getCustomForms(): Observable<any>{
    return new Observable((observer) => {
        if ( this.cachedCustomForms != null) {
          observer.next(this.cachedCustomForms)
        } else {
          this.customformsService.customformslist(this.accessToken).subscribe((customforms) => {
            console.log("Obtenidos Customforms")
            this.cachedCustomForms = customforms;
            observer.next(this.cachedCustomForms);

          })
        }
    });
  }

  /**
   * Actualiza el usuario en sesión
   * @returns
   */
  updateUser(): Observable<boolean>{
    return new Observable((observer) => {
      console.log("El accesstoken es "+this.accessToken);
      this.apiUserService.user(this.accessToken).subscribe((usuario) => {

        console.log(usuario);
        if(usuario != null){
          this.user = usuario;

          this.isAuthenticated = true;
          observer.next(this.isAuthenticated);
          this.triggerSessionCreated();
        }else{
          observer.next(false);
        }


      }, error => {
        console.log(error);
        this.closeSession();
        observer.next(false);
      });
    })
  }

  /**
   * Cierra la sesión
   * @returns
   */
  closeSession(): Observable<boolean>{
    return new Observable((observer) => {
          this.authService.logout('email').subscribe(() => {
            this.user=null;
            this.accessToken = '';
            this.removeCachedEntitiesList();
            this.cachedCompaniesList = null;
            this.removeCachedFieldList();
            this.cachedFramelinksList = null;
            this.cachedUsersList = null;
            this.cachedCustomForms = null;
            this.cachedRegionsList = null;
            this.cachedCustomFullEntities = null;
            this.listCustomEntitiesObserver = Array();
            this.listSessionObserver = Array();
            this.listCustomEntityTypesObserver = Array();
            this.cachedCustomFullEntityTypes = null;
            this.isAuthenticated = false;
            console.log("SE han destruido los datos de sesion");
            console.log(this)
            console.log("SESSION CLOSED")
            observer.next(true);
        });
    })


  }

  /**
   * Comprueba si la sesión está autenticada
   * @returns
   */
  checkAuthenticated(): Observable<boolean>{

    console.log("Comprobamos si el usuario está autenticado");

    return new Observable((observer) => {
      if(!this.isAuthenticated){

        if(typeof this.accessToken != 'undefined' && this.accessToken != '' && this.accessToken != null){

          this.updateUser().subscribe((exito)=>{
            console.log(exito);
            if(!exito){
              console.log("El token actual no es válido. Lo borramos")
              this.accessToken = null;
              console.log("El token actual es "+ this.accessToken)
            }
            observer.next(exito);
          });
        }else{
          this.authService.getToken().subscribe((token) => {
            if(token != null && token.toString() != '' && token.isValid()){
              this.accessToken = "Bearer "+token.toString();
              this.updateUser().subscribe((exito)=>{
                observer.next(exito);
              });
            }else{
              observer.next(false);
            }
          })

        }

      }else{
        observer.next(this.isAuthenticated);
      }

    })
  }

}
